import CircularProgress from '@mui/material/CircularProgress';

const LoadingModal = () => {

	return (
		<div className="modal opaque">
			<CircularProgress />
		</div>
	)
}

export default LoadingModal
